import type { Address } from "@guestbook/shared";

/**
 * Composes the parts of an `Address` into a single-line, comma-separated mailing
 * address, dropping blank components. Returns `null` when nothing is present.
 * Accepts a partial address so callers holding only a subset of fields (e.g. the
 * CSV import preview) can format what they have.
 */
export function formatAddress(address: Partial<Address> | undefined): string | null {
  if (!address) return null;
  const parts = [
    address.line1,
    address.line2,
    address.city,
    address.stateCode ?? address.stateName,
    address.postalCode,
    address.countryName ?? address.countryCode,
  ].filter((part): part is string => Boolean(part && part.trim()));
  return parts.length > 0 ? parts.join(", ") : null;
}
